import { Check, Star } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_fb11634d-0cf3-4470-a5e6-878c1ff83f74/artifacts/mvtk1hfo_IMG_8806.jpeg";

const POINTS = [
  "Family-run, locally owned in Collegeville, PA",
  "Same crew every visit — we know your property",
  "Fully licensed, insured, and background-checked",
  "Honest pricing with detailed written estimates",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[var(--rr-bg-deep)]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 relative reveal">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] border border-white/5">
              <img
                src={ABOUT_IMG}
                alt="Freshly sealcoated estate driveway by Rapid Response"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--rr-bg)]/60 to-transparent" />
            </div>

            {/* Floating review badge */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-[var(--rr-surface)] border border-white/10 rounded-2xl px-6 py-5 shadow-2xl max-w-[260px]">
              <div className="flex items-center gap-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3.5 w-3.5 fill-[var(--rr-accent)] text-[var(--rr-accent)]" />
                ))}
                <span className="ml-1 text-sm font-semibold text-white">5.0</span>
              </div>
              <p className="mt-2 text-xs text-[var(--rr-text-muted)] leading-relaxed">
                Across 11 verified Google reviews — homeowners trust Zach and the crew.
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 reveal">
            <p className="overline">About Rapid Response</p>
            <h2 className="mt-5 font-display text-4xl md:text-5xl font-semibold tracking-tighter text-white">
              The phone gets answered.
              <br />
              <span className="text-[var(--rr-text-muted)]">The work gets done.</span>
            </h2>
            <div className="mt-7 space-y-5 text-[var(--rr-text-muted)] text-lg leading-relaxed">
              <p>
                Rapid Response Property Services started with a simple idea: stop
                making homeowners chase three contractors for one yard. Today,
                we're a small, hard-working crew based out of Collegeville
                serving Montgomery County and the surrounding townships.
              </p>
              <p>
                Whether it's a driveway that needs a fresh coat, a property
                that's overdue for a cleanup, or six inches of overnight snow —
                you call once, and we show up.
              </p>
            </div>

            <ul className="mt-9 grid sm:grid-cols-2 gap-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[15px] text-white/90">
                  <span className="mt-1 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[var(--rr-primary)]/20 text-[var(--rr-accent)]">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {p}
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="#quote"
                data-testid="about-cta-quote"
                className="inline-flex items-center px-6 h-12 rounded-full bg-[var(--rr-primary)] hover:bg-[var(--rr-primary-hover)] text-white font-semibold transition-colors"
              >
                Request a quote
              </a>
              <a
                href="#gallery"
                data-testid="about-cta-work"
                className="inline-flex items-center px-6 h-12 rounded-full border border-white/15 text-white hover:bg-white/5 transition-colors"
              >
                See our work
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
